import { useFeatureFlags } from '@/providers/FeatureFlagProvider';

/**
 * The donation domain (gifts, tax receipts, donor dashboard, nonprofit/org +
 * impact updates) is gated behind the `EnableDonations` feature flag. It is off
 * until the flag is turned on in the feature-flag service.
 */
export function useDonationsEnabled() {
  const { featureFlags, isLoading } = useFeatureFlags();
  return { enabled: !!featureFlags?.EnableDonations, isLoading };
}
